import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: Layout,
        redirect: '/Home',
        children: [
            {
                path: 'RU',
                component: () => import('@/views/home/index'),
                name: 'RU',
                meta: { isAppW100P: true }
            },
            {
                path: 'Home',
                component: () => import('@/views/home/index'),
                name: 'Home',
                meta: { isAppW100P: true }
            },
            {
                path: 'Event',
                component: () => import('@/views/event/index'),
                name: 'Event',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'JoinChannel',
                component: () => import('@/views/joinChannel/index'),
                name: 'JoinChannel',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'SignIn',
                component: () => import('@/views/signIn/index'),
                name: 'SignIn',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, isAppW100P: true }
            },
            {
                path: 'SigninRecord',
                component: () => import('@/views/signinRecord/index'),
                name: 'SigninRecord',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, isAppW100P: true }
            },
            {
                path: 'Turntable',
                component: () => import('@/views/turntable/index'),
                name: 'Turntable',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'Pinduoduo',
                component: () => import('@/views/pinduoduo/index'),
                name: 'Pinduoduo',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'WeeklySalary',
                component: () => import('@/views/weeklySalary/index'),
                name: 'WeeklySalary',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'WeeklyRescue',
                component: () => import('@/views/weeklyRescue/index'),
                name: 'WeeklyRescue',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'WeeklyRescueRecord',
                component: () => import('@/views/weeklyRescueRecord/index'),
                name: 'WeeklyRescueRecord',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'WeeklySalaryRecord',
                component: () => import('@/views/weeklySalaryRecord/index'),
                name: 'WeeklySalaryRecord',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'Affiliate',
                component: () => import('@/views/affiliate/index'),
                name: 'Affiliate',
                meta: { isMobileHideFooter: true }
            },
            {
                path: 'PersonBox',
                component: () => import('@/views/person/index'),
                // name: 'PersonBox',
                children: [
                    {
                        path: '',
                        component: () => import('@/views/person/modules/index'),
                        name: 'Person',
                        meta: { isMobileHideFooter: true }
                    },
                    {
                        path: 'RedemptionRecords',
                        component: () => import('@/views/person/modules/RedemptionRecords'),
                        name: 'RedemptionRecords',
                        meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, isMobileHidePerson: true }
                    },
                    {
                        path: 'ChangePwd',
                        component: () => import('@/views/person/modules/changePwd'),
                        name: 'ChangePwd',
                        meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, isMobileHidePerson: true }
                    },
                    {
                        path: 'Transaction',
                        component: () => import('@/views/person/modules/Transaction'),
                        name: 'Transaction',
                        meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, isMobileHidePerson: true }
                    },
                    {
                        path: 'History',
                        component: () => import('@/views/person/modules/betHistory'),
                        name: 'History',
                        meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, isMobileHidePerson: true }
                    },
                    {
                        path: 'Language',
                        component: () => import('@/views/person/modules/Language'),
                        name: 'Language',
                        meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, isMobileHidePerson: true }
                    },
                    {
                        path: 'DownApp',
                        component: () => import('@/views/person/modules/DownApp'),
                        name: 'DownApp',
                        meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, isMobileHidePerson: true }
                    }
                ]
            },
            {
                path: 'Casino/:params',
                component: () => import('@/views/casino/index'),
                name: 'Casino',
                meta: { isMobileOnlyCustomer: true }
            },
            {
                path: 'Providers',
                component: () => import('@/views/Providers/index'),
                name: 'Providers',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, isAppW100P: true }
            },
            {
                path: 'SubGame/:params',
                component: () => import('@/views/subGame/index'),
                name: 'SubGame',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, isAppW100P: true }
            },
            {
                path: 'vip',
                component: () => import('@/views/vip/index'),
                name: 'vip',
                meta: { isMobileHideFooter: true, isAppW100P: true }
            },
            {
                path: 'wallet',
                component: () => import('@/views/wallet/index'),
                name: 'wallet',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'setting',
                component: () => import('@/views/setting/index'),
                name: 'setting',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'PromotionCustom/:timestamp/:params',
                component: () => import('@/views/promotionCustom/index'),
                name: 'PromotionCustom',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'MsgDetail/:params',
                component: () => import('@/views/msgDetail/index'),
                name: 'MsgDetail',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'depositBonus',
                component: () => import('@/views/depositBonus/index'),
                name: 'depositBonus',
                meta: { isMobileOnlyCustomer: false, isMobileHideHeader: false }
            },
            {
                path: 'notification',
                component: () => import('@/views/notification/index'),
                name: 'notification',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true }
            },
            {
                path: 'Sports',
                component: () => import('@/views/sports/index'),
                name: 'Sports',
                meta: { isMobileHideFooter: true, isMobileHideHeader: true, isMobileHideTabbar: true, keepAlive: false }
            }
        ]
    },
    {
        path: '/depositWv',
        component: () => import('@/views/depositWv/index'),
        name: 'depositWv'
    },
    {
        path: '/SignIn',
        component: () => import('@/views/signIn/index')
    },
    {
        path: '/Search',
        component: () => import('@/views/search/index')
    },
    {
        path: '/Agent',
        component: () => import('@/views/agent/index')
    },
    {
        path: '/TimedRedPacket',
        component: () => import('@/views/timedRedPacket/index')
    },
    {
        path: '/Pending',
        component: () => import('@/views/pending/index')
    },
    {
        path: '/PendingHistory',
        component: () => import('@/views/pendingHistory/index')
    },
    {
        path: '/LossSupport',
        component: () => import('@/views/lossSupport/index')
    },
    {
        path: '/Rebate',
        component: () => import('@/views/rebate/index')
    },
    {
        path: '/downAppPWA',
        component: () => import('@/views/downAppPWA/index'),
        name: 'downAppPWA'
    },
    {
        path: '/Validate',
        component: () => import('@/views/Validate/index'),
        name: 'Validate'
    },
    {
        path: '/scratchCards',
        component: () => import('@/views/scratchCards/index'),
        name: 'scratchCards'
    },
    {
        path: '/withdrawPwd',
        component: () => import('@/views/withdrawPwd/index'),
        name: 'withdrawPwd'
    },
    {
        path: '/redEnvelope',
        component: () => import('@/views/redEnvelope/index'),
        name: 'redEnvelope'
    },
    {
        path: '/RedemptionCode',
        component: () => import('@/views/RedemptionCode/index'),
        name: 'RedemptionCode'
    }
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
